module.exports = __webpack_public_path__ + "blacksalad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blacksalad.png
// module id = 866
// module chunks = 0